export const enum PickingBaselineEnum  {
  below = 'below',
  met = 'met',
}